import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import FilterBar from './filterBar';
import PhysicianEngagement from './physicianEngagement';
import DistrictBreakdown from './districtBreakdown';
import SearchUsingFilter from './searchUsingFilter';
import NPITable from './npiTable';
import { useDispatch, useSelector } from 'react-redux';
import { getFieldEngagement, getFieldExtendedRegion, getFieldEngagementSegment } from '../../../redux/thunks/engagementThunks';
import { REZLIDHIA_COMPANY_ID } from '../../../constants';
import FieldEngagementInfo from './digitalEngagementInfo';
import { actions as fieldEngagementActions } from '../../../redux/reducers/fieldEngagementReducer';
import { getCompanyConfigurationByTag } from '../../../redux/thunks/companyThunks';

const FieldPhysicianEngagement = (props) => {
    const {} = props;
    const dispatch = useDispatch();
    const { company } = useSelector((state) => state.company);
    const { startDateRange, endDateRange } = useSelector((state) => state.filter);
    const { companyConfig } = useSelector(state => state.adminSettings);
    const { value } = companyConfig;
    const { resetToInitialState } = fieldEngagementActions;
    useEffect(() => {
        if (company.id) {
            dispatch(getCompanyConfigurationByTag({ companyId: company.id }));
        }
    }, [company.id]);
    const isConfigReady = companyConfig && Object.keys(companyConfig).length > 0;
    useEffect(() => {
        if (company.id || isConfigReady) {
            dispatch(resetToInitialState());
            dispatch(getFieldEngagement({
                companyId: company.id, startRange: startDateRange, endRange: endDateRange//isUnified: value?.toLowerCase() === 'true' || false
            }));
            // if(company.id === REZLIDHIA_COMPANY_ID){
            //     dispatch(getFieldExtendedRegion(
            //         {
            //             companyId: company.id,
            //             startRange: startDateRange,
            //             endRange: endDateRange,
            //             //isUnified: value?.toLowerCase() === 'true' || false
            //         }
            //     ));
            // }
        }
    }, [company, startDateRange, endDateRange,isConfigReady]);

    return (
        <>
            <FilterBar />
            <Grid container spacing={2}>
                {/* Digital Physician Engagement */}
                <Grid item xs={12}>
                    <FieldEngagementInfo/>
                </Grid>
                {/* PhysicianEngagement by Channels and Segments */}
                <Grid item xs={12}>
                    <PhysicianEngagement />
                </Grid>
                {/* District Breakdown of Field Physician Engagement */}
                <Grid item xs={12}>
                    <DistrictBreakdown />
                </Grid>
                {/* Field Physician Engagement Metrics */}
                {/* <Grid item xs={12}>
                    <EngagementMetrics />
                </Grid> */}
                {/* Filters and Search */}
                <Grid item xs={12}>
                    <SearchUsingFilter />
                </Grid>
                {/* List of Npi */}
                <Grid item xs={12} sx={{ minWidth: 0 }}>
                    <NPITable />
                </Grid>
            </Grid>
        </>
    );
};

export default FieldPhysicianEngagement;
